const PESSOA_DOC_TIPO = {
    AUD: { id: 'AUD', descricao: 'Auditoria' },
    FR: { id: 'FR', descricao: 'Fato relavante' }
};

module.exports = PESSOA_DOC_TIPO;
